import styled, { css } from "styled-components"

export const Container = styled.section`
    width: 100%;
`

export const Button = styled.button`
    width: 100%;
    background: #7A05A7;
    padding: 1rem 0;
    border: none;
    font-size: 1rem;
    margin-top: 1rem;
    color: #7A05A7;
    font-weight: bold;
    border-radius: 4px;
    transition: all .3s;

    position: relative;
    transform: translateZ(0);
    backface-visibility: hidden;
    -moz-osx-font-smoothing: grayscale;


    &:hover {
        color: #FFF;
    }

    &:before {
        content: "";
        position: absolute;
        z-index: -1;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #FFF;
        transform: scaleX(1);
        transform-origin: 50%;
        border-radius: 4px;
        transition: transform .3s ease-out;
        border: 1px solid #f5f0eb;
    }

    &:hover:before {
        transform: scaleX(0);
    }

    ${props => props.loadingMoreBusiness && css`
        opacity: 0.5;
        color: #FFF;

        &:before {
            display: none;
        }
    `}
`

export const Sector = styled.div`
    width: 7rem;
    height: 4rem;
    background-image: url("${props => props.img}");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    transition: transform 0.2s ease;

    p{
        position: absolute;
        bottom: -1.1rem;
        width: 100%;
        text-align: center;
        font-size: 0.7rem;
        color: #717171;
    }

    &:hover {
        transform: scale(1.1);
    }
`

export const Businesses = styled.div`
    margin-top: 1.5rem;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 0.5rem;
    width: 100%;
`
